import EndpointsBase from "../EndpointsBase";

class ReviewEndpoints extends EndpointsBase {
  loadOrderForReview(input: string, operatorId: number, workstationId: number) {
    return this._sendRequest({
      method: "review/order",
      headers: this._getAuthHeader(operatorId, workstationId),
      data: { input },
      run: this.server.getData,
    });
  }

  loadContentImage(boxBarcode: string) {
    return this._sendRequest({
      method: "review/imageraw",
      data: {boxBarcode},
      run: this.server.getData
    });
  }

  restartDelivery = (operatorId: number, workstationId: number, invoiceNumber: number) => {
    return this._sendRequest({
      method: "review/restartdelivery",
      headers: this._getAuthHeader(operatorId, workstationId),
      data: { invoiceNumber },
      run: this.server.getData,
    })
  }
  continueDelivery =(operatorId: number, workstationId: number, invoiceNumber: number) => {
    return this._sendRequest({
      method: "review/continuedelivery",
      headers: this._getAuthHeader(operatorId, workstationId),
      data: { invoiceNumber },
      run: this.server.getData,
    });
  }
  resetArticleWeights(
    operatorId: number,
    workstationId: number,
    invoiceNumber: number,
    boxBarcode: string,
    hasCorrectContent: boolean | null = null
  ) {
    return this._sendRequest({
      method: "review/resetWeight",
      headers: this._getAuthHeader(operatorId, workstationId),
      data: { invoiceNumber, boxBarcode, hasCorrectContent },
      run: this.server.getData,
    });
  }
  printShippingLabelCopy(
    operatorId: number,
    workstationId: number,
    boxBarcode: string,
    verifiedRXBags: number[] | null = null
  ) {
    return this._sendRequest({
      method: "review/label/print",
      headers: this._getAuthHeader(operatorId, workstationId),
      data: { boxBarcode, verifiedRXBags },
      run: this.server.getData,
    });
  }
  getShippingMethods(
    operatorId: number,
    workstationId: number,
    shippingMethod: number,
    shopID: number,
    orderNumber: number
  ) {
    return this._sendRequest({
      method: "review/shippingmethods",
      headers: this._getAuthHeader(operatorId, workstationId),
      data: { shippingMethod, shopID, orderNumber },
      run: this.server.getData,
    });
  }
  printNewLabel(
    operatorID: number,
    workstationID: number,
    shippingID: number,
    shippingMethod: number,
    cancelOldLabel: boolean
  ) {
    return this._sendRequest({
      method: "review/printnewlabel",
      headers: this._getAuthHeader(operatorID, workstationID),
      data: { shippingID, shippingMethod, cancelOldLabel },
      run: this.server.getData,
    });
  }
  ackValidationMsg(
    messageId: string
  ){
    return this._sendRequest({
      method: "review/boxvalidationmsg/ack",
      data:{messageId},
      run: this.server.postData
    })
  }
}

export default new ReviewEndpoints();
